(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Announcement bar close functionality
  document.addEventListener('DOMContentLoaded', function() {
    const closeButton = document.querySelector('[data-announcement-close]');
    const announcementBar = document.querySelector('.announcement-bar');
    
    if (closeButton && announcementBar) {
      closeButton.addEventListener('click', function() {
        announcementBar.style.display = 'none';
        
        // Store in localStorage to remember user's choice
        localStorage.setItem('announcement-closed', 'true');
      });
    }
    
    // Check if user previously closed the announcement
    if (localStorage.getItem('announcement-closed') === 'true') {
      if (announcementBar) {
        announcementBar.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-marquee"] && !Shopify.designMode) return;
  try {
    
  // Brand marquee animation with CSS fallback to JavaScript
  let isPaused = false;
  let isJavaScriptAnimation = false;
  let animationId = null;

  document.addEventListener('DOMContentLoaded', function() {
    initBrandMarquee();
  });

  // Also reinitialize when Shopify theme editor updates the section
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('brand-marquee')) {
      setTimeout(() => initBrandMarquee(), 100);
    }
  });

  // Reinitialize when section settings change
  document.addEventListener('shopify:section:reorder', function(event) {
    setTimeout(() => initBrandMarquee(), 100);
  });

  document.addEventListener('shopify:section:select', function(event) {
    if (event.detail.sectionId.includes('brand-marquee')) {
      setTimeout(() => initBrandMarquee(), 100);
    }
  });

  function initBrandMarquee() {
    const scrollContainer = document.querySelector('[data-brand-marquee-scroll]');
    if (!scrollContainer) return;

    console.log('Brand marquee found, initializing animation...');

    // Force animation restart by removing and re-adding the animation
    scrollContainer.style.animation = 'none';
    scrollContainer.offsetHeight; // Trigger reflow
    scrollContainer.style.animation = '';

    // Check if CSS animation is working after 1 second
    setTimeout(() => {
      const computedStyle = getComputedStyle(scrollContainer);
      const isAnimating = computedStyle.animationName !== 'none';
      
      if (!isAnimating) {
        console.log('CSS animation failed, using JavaScript fallback');
        startJavaScriptAnimation();
      } else {
        console.log('CSS animation working:', computedStyle.animationName);
      }
    }, 1000);

    // Pause animation on hover/touch
    scrollContainer.addEventListener('mouseenter', function() {
      if (isJavaScriptAnimation) {
        isPaused = true;
      } else {
        scrollContainer.style.animationPlayState = 'paused';
      }

    });

    scrollContainer.addEventListener('mouseleave', function() {
      if (isJavaScriptAnimation) {
        isPaused = false;
      } else {
        scrollContainer.style.animationPlayState = 'running';
      }

    });

    // Pause on touch for mobile
    scrollContainer.addEventListener('touchstart', function() {
      if (isJavaScriptAnimation) {
        isPaused = true;
      } else {
        scrollContainer.style.animationPlayState = 'paused';
      }
    });

    scrollContainer.addEventListener('touchend', function() {
      if (isJavaScriptAnimation) {
        isPaused = false;
      } else {
        scrollContainer.style.animationPlayState = 'running';
      }
    });
  }



  function startJavaScriptAnimation() {
    const scrollContainer = document.querySelector('[data-brand-marquee-scroll]');
    if (!scrollContainer) return;

    isJavaScriptAnimation = true;
    console.log('Starting JavaScript animation...');
    
    let position = 0;
    const speed = 0.5; // pixels per frame for smooth movement
    
    function animate() {
      if (!isPaused) {
        position -= speed;
        
        // When we've moved enough, reset to start seamlessly
        if (position <= -200) {
          position = 0;
        }
        
        scrollContainer.style.transform = `translateX(${position}px)`;
      }
      
      animationId = requestAnimationFrame(animate);
    }
    
    animate();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose = document.querySelector('[data-filter-close]');
  const filters = document.querySelector('[data-filters]');
  const filterOverlay = document.querySelector('[data-filter-overlay]');
  const sortToggle = document.querySelector('[data-sort-toggle]');
  const sortDropdown = document.querySelector('[data-sort-dropdown]');
  const productsGrid = document.querySelector('[data-products-grid]');
  const clearFilters = document.querySelector('[data-clear-filters]');
  const applyFilters = document.querySelector('[data-apply-filters]');

  // Filter toggle
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', function() {
      filters.classList.add('is-open');
      if (filterOverlay) filterOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (filterClose && filters) {
    filterClose.addEventListener('click', function() {
      filters.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Close filters when clicking overlay
  if (filterOverlay) {
    filterOverlay.addEventListener('click', function() {
      filters.classList.remove('is-open');
      filterOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Sorting
  if (sortToggle && sortDropdown) {
    sortToggle.addEventListener('click', function() {
      sortDropdown.classList.toggle('is-open');
      
      if (sortDropdown.classList.contains('is-open')) {
        // Position the dropdown correctly when opened
        const rect = sortToggle.getBoundingClientRect();
        sortDropdown.style.top = (rect.bottom + window.scrollY + 8) + 'px';
        sortDropdown.style.right = (window.innerWidth - rect.right) + 'px';
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!sortToggle.contains(e.target)) {
        sortDropdown.classList.remove('is-open');
      }
    });

    // Handle sort option clicks
    const sortOptions = document.querySelectorAll('[data-sort-value]');
    sortOptions.forEach(option => {
      option.addEventListener('click', function() {
        const sortValue = this.dataset.sortValue;
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });
  }

  // Filter functionality
  let activeFilters = {
    vendor: [],
    type: [],
    priceMin: 0,
    priceMax: 5000
  };

  // Price range inputs
  const priceMinInput = document.querySelector('[data-price-min]');
  const priceMaxInput = document.querySelector('[data-price-max]');

  if (priceMinInput && priceMaxInput) {
    priceMinInput.addEventListener('input', function() {
      activeFilters.priceMin = parseInt(this.value) || 0;
    });

    priceMaxInput.addEventListener('input', function() {
      activeFilters.priceMax = parseInt(this.value) || 5000;
    });
  }

  // Vendor and type filters
  const vendorFilters = document.querySelectorAll('[data-vendor-filter]');
  const typeFilters = document.querySelectorAll('[data-type-filter]');

  vendorFilters.forEach(filter => {
    filter.addEventListener('change', function() {
      if (this.checked) {
        activeFilters.vendor.push(this.value);
      } else {
        activeFilters.vendor = activeFilters.vendor.filter(v => v !== this.value);
      }
    });
  });

  typeFilters.forEach(filter => {
    filter.addEventListener('change', function() {
      if (this.checked) {
        activeFilters.type.push(this.value);
      } else {
        activeFilters.type = activeFilters.type.filter(t => t !== this.value);
      }
    });
  });

  // Clear filters
  if (clearFilters) {
    clearFilters.addEventListener('click', function() {
      vendorFilters.forEach(filter => filter.checked = false);
      typeFilters.forEach(filter => filter.checked = false);
      if (priceMinInput) priceMinInput.value = 0;
      if (priceMaxInput) priceMaxInput.value = 5000;
      activeFilters = { vendor: [], type: [], priceMin: 0, priceMax: 5000 };
      filterProducts();
    });
  }

  // Apply filters
  if (applyFilters) {
    applyFilters.addEventListener('click', function() {
      filterProducts();
      filters.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Filter products function
  function filterProducts() {
    const products = document.querySelectorAll('[data-product]');
    products.forEach(product => {
      const vendor = product.dataset.vendor;
      const type = product.dataset.type;
      const price = parseInt(product.dataset.price); // Price in cents
      
      let show = true;
      if (activeFilters.vendor.length > 0 && !activeFilters.vendor.includes(vendor)) show = false;
      if (activeFilters.type.length > 0 && !activeFilters.type.includes(type)) show = false;
      
      // Compare price (in cents) with user input (in euros/dollars)
      if (price < (activeFilters.priceMin * 100) || price > (activeFilters.priceMax * 100)) show = false;
      
      product.style.display = show ? 'block' : 'none';
    });
  }

  // Wishlist functionality
  const wishlistBtns = document.querySelectorAll('[data-wishlist-btn]');
  wishlistBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const icon = this.querySelector('.collection-product__wishlist-icon');
      if (icon.style.color === 'red') {
        icon.style.color = '#666';
        this.style.background = 'white';
      } else {
        icon.style.color = 'red';
        this.style.background = '#ff6b6b';
      }
    });
  });


  // LOAD MORE AJAX
  const loadMoreBtn = document.querySelector('[data-load-more]');

  if (loadMoreBtn && productsGrid) {
    loadMoreBtn.addEventListener('click', async function () {
      const nextUrl = this.dataset.nextUrl;

      if (!nextUrl) return;

      this.classList.add('loading');
      this.textContent = 'Loading...';

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelector('[data-products-grid]');
        const newLoadMoreBtn = doc.querySelector('[data-load-more]');

        if (newProducts) {
          productsGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        }

        if (newLoadMoreBtn) {
          this.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
          this.textContent = 'Load more';
          this.classList.remove('loading');
        } else {
          this.parentElement.remove();
        }

      } catch (error) {
        console.error(error);
        this.textContent = 'Erreur, réessayer';
        this.classList.remove('loading');
      }
    });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose = document.querySelector('[data-filter-close]');
  const filters = document.querySelector('[data-filters]');
  const sortToggle = document.querySelector('[data-sort-toggle]');
  const sortDropdown = document.querySelector('[data-sort-dropdown]');
  const productsGrid = document.querySelector('[data-products-grid]');
  const clearFilters = document.querySelector('[data-clear-filters]');
  const applyFilters = document.querySelector('[data-apply-filters]');

  // Filter toggle
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', function() {
      filters.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (filterClose && filters) {
    filterClose.addEventListener('click', function() {
      filters.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Close filters when clicking overlay
  if (filters) {
    filters.addEventListener('click', function(e) {
      if (e.target === filters) {
        filters.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // Sorting
  if (sortToggle && sortDropdown) {
    sortToggle.addEventListener('click', function() {
      sortDropdown.classList.toggle('is-open');
      
      if (sortDropdown.classList.contains('is-open')) {
        // Position the dropdown correctly when opened
        const rect = sortToggle.getBoundingClientRect();
        sortDropdown.style.top = (rect.bottom + window.scrollY + 8) + 'px';
        sortDropdown.style.right = (window.innerWidth - rect.right) + 'px';
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!sortToggle.contains(e.target)) {
        sortDropdown.classList.remove('is-open');
      }
    });

    // Handle sort option clicks
    const sortOptions = document.querySelectorAll('[data-sort-value]');
    sortOptions.forEach(option => {
      option.addEventListener('click', function() {
        const sortValue = this.dataset.sortValue;
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });
  }

  // Filter functionality
  let activeFilters = {
    vendor: [],
    type: [],
    priceMin: 0,
    priceMax: 5000
  };

  // Price range inputs
  const priceMinInput = document.querySelector('[data-price-min]');
  const priceMaxInput = document.querySelector('[data-price-max]');
  const priceMinDisplay = document.querySelector('.price-range__min');
  const priceMaxDisplay = document.querySelector('.price-range__max');

  if (priceMinInput && priceMaxInput) {
    priceMinInput.addEventListener('input', function() {
      activeFilters.priceMin = parseInt(this.value);
      if (priceMinDisplay) {
        priceMinDisplay.textContent = '$' + this.value;
      }
    });

    priceMaxInput.addEventListener('input', function() {
      activeFilters.priceMax = parseInt(this.value);
      if (priceMaxDisplay) {
        priceMaxDisplay.textContent = '$' + this.value;
      }
    });
  }

  // Vendor and type filters
  const vendorFilters = document.querySelectorAll('[data-vendor-filter]');
  const typeFilters = document.querySelectorAll('[data-type-filter]');

  vendorFilters.forEach(filter => {
    filter.addEventListener('change', function() {
      if (this.checked) {
        activeFilters.vendor.push(this.value);
      } else {
        activeFilters.vendor = activeFilters.vendor.filter(v => v !== this.value);
      }
    });
  });

  typeFilters.forEach(filter => {
    filter.addEventListener('change', function() {
      if (this.checked) {
        activeFilters.type.push(this.value);
      } else {
        activeFilters.type = activeFilters.type.filter(t => t !== this.value);
      }
    });
  });

  // Clear filters
  if (clearFilters) {
    clearFilters.addEventListener('click', function() {
      // Reset checkboxes
      vendorFilters.forEach(filter => filter.checked = false);
      typeFilters.forEach(filter => filter.checked = false);
      
      // Reset price range
      if (priceMinInput) priceMinInput.value = 0;
      if (priceMaxInput) priceMaxInput.value = 5000;
      if (priceMinDisplay) priceMinDisplay.textContent = '$0';
      if (priceMaxDisplay) priceMaxDisplay.textContent = '$5000';
      
      // Reset active filters
      activeFilters = {
        vendor: [],
        type: [],
        priceMin: 0,
        priceMax: 5000
      };
      
      // Show all products
      filterProducts();
    });
  }

  // Apply filters
  if (applyFilters) {
    applyFilters.addEventListener('click', function() {
      filterProducts();
      filters.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Filter products function
  function filterProducts() {
    const products = document.querySelectorAll('[data-product]');
    
    products.forEach(product => {
      const vendor = product.dataset.vendor;
      const type = product.dataset.type;
      const price = parseInt(product.dataset.price);
      
      let show = true;
      
      // Check vendor filter
      if (activeFilters.vendor.length > 0 && !activeFilters.vendor.includes(vendor)) {
        show = false;
      }
      
      // Check type filter
      if (activeFilters.type.length > 0 && !activeFilters.type.includes(type)) {
        show = false;
      }
      
      // Check price filter
      if (price < activeFilters.priceMin || price > activeFilters.priceMax) {
        show = false;
      }
      
      // Show/hide product
      product.style.display = show ? 'block' : 'none';
    });
  }

  // Wishlist functionality
  const wishlistBtns = document.querySelectorAll('[data-wishlist-btn]');
  wishlistBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const icon = this.querySelector('.collection-product__wishlist-icon');
      if (icon.style.color === 'red') {
        icon.style.color = '#666';
        this.style.background = 'white';
      } else {
        icon.style.color = 'red';
        this.style.background = '#ff6b6b';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
addEventListener("load", () => {
  if (Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }
  
  const slideSwiper = new Swiper(".hero-banner .swiper", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      transitionEnd: function () {
        document.querySelectorAll('.hero-banner__box-container').forEach(container => {
          container.classList.remove('near-end-slide');
        });
        
        const totalSlides = this.slides.length;
        const nearEndIndex = totalSlides - this.params.slidesPerView;
        
        if (this.activeIndex >= nearEndIndex) {
          this.slides[this.activeIndex].closest('.hero-banner__box-container').classList.add('near-end-slide');
        }
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.product-section');
  if (!section) return;
  
  const prevBtn = section.querySelector('.nav-prev');
  const nextBtn = section.querySelector('.nav-next');
  const productRow = section.querySelector('.product-row');
  
  if (!prevBtn || !nextBtn || !productRow) return;
  
  const scrollAmount = 300;
  
  prevBtn.addEventListener('click', function() {
    productRow.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });
  
  nextBtn.addEventListener('click', function() {
    productRow.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
  
  // Update navigation state based on scroll position
  function updateNavigation() {
    const isAtStart = productRow.scrollLeft <= 0;
    const isAtEnd = productRow.scrollLeft >= productRow.scrollWidth - productRow.clientWidth;
    
    prevBtn.disabled = isAtStart;
    nextBtn.disabled = isAtEnd;
  }
  
  productRow.addEventListener('scroll', updateNavigation);
  updateNavigation();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
// Product page functionality
document.addEventListener('DOMContentLoaded', function() {
  // Image navigation
const productGallery = document.querySelector('.product-images');

if (productGallery) {
  const mainImage = productGallery.querySelector('.product-images__main-image');
  const thumbnails = productGallery.querySelectorAll('.product-images__thumbnail');
  const prevBtn = productGallery.querySelector('.product-images__nav--prev');
  const nextBtn = productGallery.querySelector('.product-images__nav--next');
}
  
  if (mainImage && thumbnails.length > 0) {
    let currentIndex = 0;
    
    // Thumbnail clicks
    thumbnails.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() {
        currentIndex = index;
        
        // Use high-resolution image from data attribute if available
        const img = this.querySelector('img');
        const highResSrc = img.dataset.highRes || img.src;
        mainImage.src = highResSrc;
        
        // Update thumbnail states
        thumbnails.forEach(function(t, i) {
          t.classList.toggle('product-images__thumbnail--active', i === index);
        });
      });
    });
    
    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        currentIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
        const targetThumb = thumbnails[currentIndex];
        
        // Use high-resolution image from data attribute if available
        const img = targetThumb.querySelector('img');
        const highResSrc = img.dataset.highRes || img.src;
        mainImage.src = highResSrc;
        
        thumbnails.forEach(function(t, i) {
          t.classList.toggle('product-images__thumbnail--active', i === currentIndex);
        });
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        currentIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
        const targetThumb = thumbnails[currentIndex];
        
        // Use high-resolution image from data attribute if available
        const img = targetThumb.querySelector('img');
        const highResSrc = img.dataset.highRes || img.src;
        mainImage.src = highResSrc;
        
        thumbnails.forEach(function(t, i) {
          t.classList.toggle('product-images__thumbnail--active', i === currentIndex);
        });
      });
    }
  }
  
  // Variant selection handling
  const variantInputs = document.querySelectorAll('.product-form__option-input[data-variant-id]');
  const variantIdInput = document.querySelector('input[name="id"]');
  const priceDisplay = document.querySelector('.product-details__price .price');
  
  variantInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (this.checked) {
        const variantId = this.dataset.variantId;
        if (variantIdInput) {
          variantIdInput.value = variantId;
        }
        
        // Update price if available
        if (priceDisplay && this.dataset.price) {
          priceDisplay.textContent = this.dataset.price;
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose = document.querySelector('[data-filter-close]');
  const filters = document.querySelector('[data-filters]');
  const sortToggle = document.querySelector('[data-sort-toggle]');
  const sortDropdown = document.querySelector('[data-sort-dropdown]');
  const productsGrid = document.querySelector('[data-products-grid]');
  const clearFilters = document.querySelector('[data-clear-filters]');
  const applyFilters = document.querySelector('[data-apply-filters]');
  const searchInput = document.querySelector('[data-search-input]');

  // Filter toggle
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', function() {
      filters.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (filterClose && filters) {
    filterClose.addEventListener('click', function() {
      filters.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Close filters when clicking overlay
  if (filters) {
    filters.addEventListener('click', function(e) {
      if (e.target === filters) {
        filters.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // Sorting
  if (sortToggle && sortDropdown) {
    sortToggle.addEventListener('click', function() {
      sortDropdown.classList.toggle('is-open');
      
      if (sortDropdown.classList.contains('is-open')) {
        // Position the dropdown correctly when opened
        const rect = sortToggle.getBoundingClientRect();
        sortDropdown.style.top = (rect.bottom + window.scrollY + 8) + 'px';
        sortDropdown.style.right = (window.innerWidth - rect.right) + 'px';
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!sortToggle.contains(e.target)) {
        sortDropdown.classList.remove('is-open');
      }
    });

    // Handle sort option clicks
    const sortOptions = document.querySelectorAll('[data-sort-value]');
    sortOptions.forEach(option => {
      option.addEventListener('click', function() {
        const sortValue = this.dataset.sortValue;
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });
  }

  // Filter functionality
  let activeFilters = {
    vendor: [],
    type: [],
    priceMin: 0,
    priceMax: 5000
  };

  // Price range inputs
  const priceMinInput = document.querySelector('[data-price-min]');
  const priceMaxInput = document.querySelector('[data-price-max]');
  const priceMinDisplay = document.querySelector('.price-range__min');
  const priceMaxDisplay = document.querySelector('.price-range__max');

  if (priceMinInput && priceMaxInput) {
    priceMinInput.addEventListener('input', function() {
      activeFilters.priceMin = parseInt(this.value);
      if (priceMinDisplay) {
        priceMinDisplay.textContent = '$' + this.value;
      }
    });

    priceMaxInput.addEventListener('input', function() {
      activeFilters.priceMax = parseInt(this.value);
      if (priceMaxDisplay) {
        priceMaxDisplay.textContent = '$' + this.value;
      }
    });
  }

  // Vendor and type filters
  const vendorFilters = document.querySelectorAll('[data-vendor-filter]');
  const typeFilters = document.querySelectorAll('[data-type-filter]');

  vendorFilters.forEach(filter => {
    filter.addEventListener('change', function() {
      if (this.checked) {
        activeFilters.vendor.push(this.value);
      } else {
        activeFilters.vendor = activeFilters.vendor.filter(v => v !== this.value);
      }
    });
  });

  typeFilters.forEach(filter => {
    filter.addEventListener('change', function() {
      if (this.checked) {
        activeFilters.type.push(this.value);
      } else {
        activeFilters.type = activeFilters.type.filter(t => t !== this.value);
      }
    });
  });

  // Clear filters
  if (clearFilters) {
    clearFilters.addEventListener('click', function() {
      // Reset checkboxes
      vendorFilters.forEach(filter => filter.checked = false);
      typeFilters.forEach(filter => filter.checked = false);
      
      // Reset price range
      if (priceMinInput) priceMinInput.value = 0;
      if (priceMaxInput) priceMaxInput.value = 5000;
      if (priceMinDisplay) priceMinDisplay.textContent = '$0';
      if (priceMaxDisplay) priceMaxDisplay.textContent = '$5000';
      
      // Reset active filters
      activeFilters = {
        vendor: [],
        type: [],
        priceMin: 0,
        priceMax: 5000
      };
      
      // Show all products
      filterProducts();
    });
  }

  // Apply filters
  if (applyFilters) {
    applyFilters.addEventListener('click', function() {
      filterProducts();
      filters.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Filter products function
  function filterProducts() {
    const products = document.querySelectorAll('[data-product]');
    
    products.forEach(product => {
      const vendor = product.dataset.vendor;
      const type = product.dataset.type;
      const price = parseInt(product.dataset.price);
      
      let show = true;
      
      // Check vendor filter
      if (activeFilters.vendor.length > 0 && !activeFilters.vendor.includes(vendor)) {
        show = false;
      }
      
      // Check type filter
      if (activeFilters.type.length > 0 && !activeFilters.type.includes(type)) {
        show = false;
      }
      
      // Check price filter
      if (price < activeFilters.priceMin || price > activeFilters.priceMax) {
        show = false;
      }
      
      // Show/hide product
      product.style.display = show ? 'block' : 'none';
    });
  }

  // Wishlist functionality
  const wishlistBtns = document.querySelectorAll('[data-wishlist-btn]');
  wishlistBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const icon = this.querySelector('.collection-product__wishlist-icon');
      if (icon.style.color === 'red') {
        icon.style.color = '#666';
        this.style.background = 'white';
      } else {
        icon.style.color = 'red';
        this.style.background = '#ff6b6b';
      }
    });
  });

  // Auto-focus search input when page loads
  if (searchInput) {
    searchInput.focus();
    // Select all text for easy replacement
    searchInput.select();
  }

// LOAD MORE AJAX
const loadMoreBtn = document.querySelector('[data-load-more]');

if (loadMoreBtn && productsGrid) {
  loadMoreBtn.addEventListener('click', async function () {

    const nextUrl = this.dataset.nextUrl;

    if (!nextUrl) return;

    this.classList.add('loading');
    this.textContent = 'Loading...';

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelector('[data-products-grid]');
      const newLoadMoreBtn = doc.querySelector('[data-load-more]');

      if (newProducts) {
        productsGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }

      if (newLoadMoreBtn) {
        this.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
        this.textContent = 'Load more';
        this.classList.remove('loading');
      } else {
        this.parentElement.remove();
      }

    } catch (error) {
      console.error(error);
      this.textContent = 'Try again';
      this.classList.remove('loading');
    }
  });
}

});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-product-rail"] && !Shopify.designMode) return;
  try {
    
class TabbedRail {
  constructor() {
    this.tabs = document.querySelectorAll('.tabbed-rail__tab');
    this.panels = document.querySelectorAll('.tabbed-rail__panel');
    this.init();
  }
  
  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
  }
  
  switchTab(clickedTab) {
    // Remove active class from all tabs and panels
    this.tabs.forEach(tab => tab.classList.remove('active'));
    this.panels.forEach(panel => panel.classList.remove('active'));
    
    // Add active class to clicked tab
    clickedTab.classList.add('active');
    
    // Show corresponding panel
    const targetPanel = document.getElementById(clickedTab.dataset.tab);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new TabbedRail();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  // Trust badges animation with CSS fallback to JavaScript
  document.addEventListener('DOMContentLoaded', function() {
    initTrustBadges();
  });

  // Also reinitialize when Shopify theme editor updates the section
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('trust-badges')) {
      setTimeout(() => initTrustBadges(), 100);
    }
  });

  // Reinitialize when section settings change
  document.addEventListener('shopify:section:reorder', function(event) {
    setTimeout(() => initTrustBadges(), 100);
  });

  document.addEventListener('shopify:section:select', function(event) {
    if (event.detail.sectionId.includes('trust-badges')) {
      setTimeout(() => initTrustBadges(), 100);
    }
  });

  let isPaused = false;
  let isJavaScriptAnimation = false;
  let animationId = null;

  function initTrustBadges() {
    const scrollContainer = document.querySelector('[data-trust-badges-scroll]');
    if (!scrollContainer) return;

    console.log('Trust badges found, initializing animation...');

    // Simple check if CSS animation is working
    setTimeout(() => {
      const computedStyle = getComputedStyle(scrollContainer);
      const isAnimating = computedStyle.animationName !== 'none' && computedStyle.animationName.includes('trust-badges-scroll');
      
      if (!isAnimating) {
        console.log('CSS animation failed, using JavaScript fallback');
        startJavaScriptAnimation();
      } else {
        console.log('CSS animation working:', computedStyle.animationName);
      }
    }, 500);

    // Pause animation on hover/touch
    scrollContainer.addEventListener('mouseenter', function() {
      if (isJavaScriptAnimation) {
        isPaused = true;
      } else {
        scrollContainer.style.animationPlayState = 'paused';
      }
      console.log('Animation paused');
    });

    scrollContainer.addEventListener('mouseleave', function() {
      if (isJavaScriptAnimation) {
        isPaused = false;
      } else {
        scrollContainer.style.animationPlayState = 'running';
      }
      console.log('Animation resumed');
    });

    // Pause on touch for mobile
    scrollContainer.addEventListener('touchstart', function() {
      if (isJavaScriptAnimation) {
        isPaused = true;
      } else {
        scrollContainer.style.animationPlayState = 'paused';
      }
    });

    scrollContainer.addEventListener('touchend', function() {
      if (isJavaScriptAnimation) {
        isPaused = false;
      } else {
        scrollContainer.style.animationPlayState = 'running';
      }
    });
  }

  function startJavaScriptAnimation() {
    const scrollContainer = document.querySelector('[data-trust-badges-scroll]');
    if (!scrollContainer) return;

    isJavaScriptAnimation = true;
    console.log('Starting JavaScript animation...');
    
    let position = 0;
    const speed = 0.5; // pixels per frame for smooth movement
    
    function animate() {
      if (!isPaused) {
        position -= speed;
        
        // When we've moved enough, reset to start seamlessly
        if (position <= -200) {
          position = 0;
        }
        
        scrollContainer.style.transform = `translateX(${position}px)`;
      }
      
      animationId = requestAnimationFrame(animate);
    }
    
    animate();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-widget"] && !Shopify.designMode) return;
  try {
    
  // Load Trustpilot widget script if not already loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Check if Trustpilot script is already loaded
    if (!window.Trustpilot) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      document.head.appendChild(script);
    }
    
    // Reinitialize Trustpilot widgets after content load
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
